<template>
  <div class="article-container">
    <div style="height: 100px;">
      <img src="../assets/img/index/header/022.png">
    </div>
    <div class="content">
      <h3>关于警惕不法分子假冒天相财富进行非法证券活动的严正声明</h3>
      <div class="text-body">
        <p>尊敬的投资者：</p>
        <p>近日，本公司发现有不法分子冒充董事长林义相及本公司工作人员身份，利用微信群、QQ群等渠道开展非法证券活动，包括但不限于直播授课、推荐股票、指导操作等有偿服务。他们使用“荐股”、“成立赔损基金”、“包赔损失”等诱导性说法，意图欺骗消费者，严重扰乱了证券市场的正常秩序，损害了投资者的合法权益，同时也对本公司声誉造成了不良影响。</p>
        <p>为维护证券市场的公平、公正和透明，保障广大投资者的合法权益，本公司郑重声明如下：</p>
        <p>一、本公司所有服务均通过企业微信平台和系统电话进行，任何以QQ、个人微信或非公司电话等方式联系投资者的行为，均属于冒用本公司名义的非法行为，请广大投资者保持警惕，切勿轻信。</p>
        <p>二、本公司从未通过任何形式的群营销方式进行客户招揽、股票推荐、操作指导等活动，也不承诺任何形式的收益或分担损失。任何以本公司及本公司工作人员名义进行的直播推荐股票、指导操作、拉人入群等行为均属假冒。</p>
        <p>三、本公司所有服务费用均通过公司实名账户收取，均签署合同并开具发票，任何以本公司名义及本公司工作人员身份要求投资者向个人账户或非本公司名称的账户汇款的行为均属假冒。</p>
        <p>四、投资者如需咨询、了解或确认本公司相关服务，请通过以下官方渠道:公司官网https://www.txcfgl.com;官方公众号“天相股多多”、“股多多淘金”、“ 股多多军师”、“巨牛智投”;咨询热线 010-66045051、申诉热线 400-101-8662。本公司将在工作时间内随时为投资者提供服务。</p>
        <p>本公司将积极配合有关部门，对冒充本公司及本公司工作人员的违法违规行为进行严厉打击，坚决维护证券市场的稳定和投资者的合法权益。对于任何冒充本公司及本公司工作人员的违法行为，本公司保留通过法律途径追究其法律责任的权利。</p>
        <p>敬请广大投资者提高警惕，切勿轻信不明来源的信息，远离非法证券活动，切实保护自身合法权益。同时，欢迎广大投资者积极向本公司举报有关违法行为，共同维护证券市场的健康发展。</p>
        <p> 特此公告！</p>
        <div class="align-right">
          <p><b>北京天相财富管理顾问有限公司</b></p>
          <p><b>2024年6月7日</b></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    data() {
      return{

      }
    }
  }
</script>
<style scoped>
.article-container {
    max-width: 900px;
    margin: 0 auto;
    padding: 2rem;
}

.header-image img {
    width: 100%;
    height: auto;
    display: block;
    margin-bottom: 1.5rem;
    font-size: 27px;
}

.content {
    text-align: justify;
    line-height: 1.6;
    font-size: 30px;
}

.text-body p {
    margin-bottom: 1rem;
    font-size: 30px;
}

h3 {
    font-size: 2rem;
    margin-bottom: 1rem;
    text-align: center;
}
.align-right{
  text-align: right;
  font-size: 30px;
}
.text-body p {
    margin-bottom: 1rem;
    font-size: 1rem !important; /* 添加这一行来强制覆盖 */
    font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/wenzhang.vue